import type { Currency } from '@ps/web-core-enums';
import { maxNumber, minNumber } from '@ps/web-shared-validators';
import React from 'react';
import { useField } from 'react-final-form';

import type { Limits } from '../../../../types/responsibleGamingLimits';
import {
  validateAmountLimit,
  validateResponsibleGamingLimit
} from '../../../../validators/responsibleGamingLimits';
import AmountCurrency from '../../../AmountCurrency/AmountCurrency';

import {
  TXTWCL_N0_Day_limit,
  TXTWCL_Please_enter_an_amount_higher__ELL,
  TXTWCL_Please_enter_an_amount_higher__ELL_1,
  TXTWCL_The_maximum_amount_for_this_li_ELL_1,
  TXTWCL_The_minimum_amount_for_this_li_ELL
} from './MonthlyLimit.messages.json';

interface Props {
  fieldName: string;
  limits: Limits;
  currency: Currency;
  limitsDisabled?: boolean;
}

const MonthlyLimit: React.FC<Props> = ({ fieldName, currency, limits, limitsDisabled }) => {
  const { limitMax, limitMin, limit } = limits?.monthly ?? {};

  useField(`${fieldName}.monthly.previousLimit`, { initialValue: limit });
  const {
    input: { value: rate }
  } = useField(`${fieldName}.rate`, { subscription: { value: true } });
  useField(`${fieldName}.weekly.previousLimit`, { initialValue: limit });
  const {
    input: { onChange: onDepositLimitsChange, value: monthlyLimit }
  } = useField(`${fieldName}.monthly.limit`, {
    initialValue: limit !== -1 ? limit : undefined,
    subscription: { value: true }
  });

  return (
    <AmountCurrency
      withPlaceholder={false}
      disabled={limitsDisabled}
      defaultCurrency={currency}
      includeCurrencies={[currency]}
      label={TXTWCL_N0_Day_limit}
      values={{ 0: 30 }}
      currencyFieldName={`${fieldName}.currency`}
      amountFieldName={`${fieldName}.monthly.limit`}
      onAmountBlur={() => monthlyLimit && onDepositLimitsChange(Number(monthlyLimit).toFixed(2))}
      validators={[
        validateAmountLimit(
          minNumber,
          TXTWCL_The_minimum_amount_for_this_li_ELL,
          limitMin,
          fieldName,
          rate
        ),
        validateAmountLimit(
          maxNumber,
          TXTWCL_The_maximum_amount_for_this_li_ELL_1,
          limitMax,
          fieldName,
          rate
        ),
        validateResponsibleGamingLimit(
          `${fieldName}.daily.limit`,
          limit,
          { ...TXTWCL_Please_enter_an_amount_higher__ELL_1, values: { 0: 24 } },
          minNumber
        ),
        validateResponsibleGamingLimit(
          `${fieldName}.weekly.limit`,
          limit,
          { ...TXTWCL_Please_enter_an_amount_higher__ELL, values: { 0: 7 } },
          minNumber
        )
      ]}
    />
  );
};

export default MonthlyLimit;
